import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { Tooltip } from 'antd'

import { QuestionCircleOutlined } from '@ant-design/icons'

import { IOptions } from '@/shared/types/data'
import { SelectFormItem } from '@/shared/ui/form-items/select-form-item'

import styles from './styles.module.scss'

const mockUnitOptions: IOptions[] = [
  { value: 'm', label: 'минуты' },
  { value: 'h', label: 'дни' },
  { value: 'd', label: 'часы' },
]

const mockValueOptions: { [key: string]: IOptions[] } = {
  m: [{ value: 15 }, { value: 30 }, { value: 45 }],
  h: Array.from({ length: 10 }, (_, i) => ({ value: i + 1 })),
  d: [{ value: 1 }, { value: 2 }, { value: 3 }],
}

interface IProps {
  disabled?: boolean
}

export const SelectUpdateFreequencyItem = ({ disabled = false }: IProps) => {
  const [valueOptions, setValueOptions] = useState<IOptions[]>([])

  const { watch, setValue } = useFormContext()

  const unitOptions: IOptions[] = mockUnitOptions
  const updateFreequencyUnit = watch('updateFreequencyUnit')

  useEffect(() => {
    setValueOptions(mockValueOptions[updateFreequencyUnit])
    setValue('updateFreequencyValue', null)
  }, [updateFreequencyUnit, setValue, setValueOptions])

  return (
    <div className={styles.item}>
      <span className={styles.label}>
        Частота обновления данных
        <Tooltip title="Частота обновления данных">
          <QuestionCircleOutlined className={styles.buttonInfo} />
        </Tooltip>
      </span>
      <SelectFormItem
        name="updateFreequencyUnit"
        options={unitOptions}
        formItemProps={{ colon: false, className: styles.itemUnit }}
        selectProps={{ disabled }}
      />
      <SelectFormItem
        name="updateFreequencyValue"
        options={valueOptions}
        formItemProps={{ colon: false, className: styles.itemValue }}
        selectProps={{ disabled: !updateFreequencyUnit || disabled }}
      />
    </div>
  )
}
